export interface IPersonProfile {
  personId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  demographics: IDemographics;
  pronouns: string;
  profilePhoto: IPhoto;
  profileLogo: IPhoto;
  accounts: IUserAccount[];
  advisorPhotos: { aws_key: string; key: string }[];
  advisorLogos: { aws_key: string; key: string }[];
}

export interface IUserAccount {
  userId: string;
  shopId: string;
  ldapId: string;
  portfolioId: string;
  isMultiShop: boolean;
  email: string;
  alternativeEmail: string;
  address: string;
  address2: string;
  city: string;
  state: string | null;
  postalCode: string;
  country: string;
  createdAt: string;
  phoneNumbers: IPhoneNumber[];
  shops: IProfileShop[];
  teams: ITeam[];
  chimeInfo: IChimeInfo;
  socialMediaLinks: ISocialMediaLink[];
  bio: IBiography[];
  testimonials: ITestimonial[];
  stateLicenses: IStateLicense[];
  title: string;
  evTitle: string;
  websiteLinks: IWebsiteLink[];
  personalEmails: IPersonalEmail[];
  personalMedia: IPersonalMedia[];
  languages: string[];
  positions: string[];
  specializations: string[];
  designations: string[];
  includeInRoster: boolean;
  loginDate: string;
  hasNoPriorProduction: boolean;
  googleId: string;
  googleProfileImage: string;
  logoutDate: string;
  isPrivateOffice: boolean;
  isNewToIndustry: boolean;
  requestLogOff: boolean;
  previousBrand: string;
  homeAddress: string;
  homeCity: string;
  homeState: string;
  homePostalCode: string;
  homeCountry: string;
  primaryShopCountry: string;
  mls: IAdvisorMls[];
  preferredContactMethod: ContactMethods | null;
}

export interface IPhoneNumber {
  type: string;
  phone: string;
}

export interface IProfileShop {
  roles: IRoles[];
  shopId: string;
  name: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  url: string;
  phone: string;
  chimeInfo: IChimeInfo;
  shopGroup: {
    chimeInfo: { type: string; chimeOfficeId: number };
    domain: string;
    id: string;
    name: string;
  };
  shopImages: IPhoto[];
}

export interface IRoles {
  roleId?: string;
  name: string;
  id: string;
  type?: string;
  description?: string;
}

export interface ITeam {
  teamId: string;
  name: string;
}

export interface IChimeInfo {
  chimeOfficeId?: number;
  memberUserId?: string;
  teamMemberId?: string;
}

export interface ISocialMediaLink {
  type: string;
  url: string;
}

export interface IBiography {
  language: string;
  value: string;
}

export interface ITestimonial {
  id: string;
  name: string;
  order: number;
  rate: number;
  [key: string]: string | number;
}

export interface IPhoto {
  key: string;
  location: string;
}

export interface IDemographics {
  degree: string;
  ethnicity: string;
  gender: string;
  sexualIdentity: string;
  veteranStatus: string;
}

export interface IStateLicense {
  state?: string;
  licenseNumber: string;
  expirationDate: string;
  licenseState?: string;
}

export interface IWebsiteLink {
  url: string;
}

export interface IPersonalEmail {
  email: string;
}

export interface IAdvisorMls {
  id: string;
  mls: IShopMls;
  state: string;
  mlsId: string;
  broker: IBroker;
}

export interface IShopMls {
  name: string;
  id: string;
  osn: string;
}

export interface IBroker {
  id: string;
  email: string;
  name: string;
}

export enum ProfileAppMode {
  OWN_PROFILE = 'Own Profile',
  OTHER_PROFILE = 'Other Profile',
}

export interface IPersonalMedia {
  type: 'photo' | 'video';
  location: string;
}

export type Currency = 'CAD' | 'USD';

export enum ContactMethods {
  Cell = 'cell',
  Home = 'home',
  Other = 'other',
  Email = 'email',
  None = 'none',
}
